import * as React from "react";

import {RouteComponentProps, withRouter} from "react-router";
import {LoadingViewState, RouterView} from "../RouterView";
import {
    AwardType,
    CurrencyDefinition,
    GameTag,
    MonetaryConfig,
    Settings,
    TurnoverContributions,
    PeriodTimeUnit,
    AwardTarget
} from "../../http/protocol";
import {Form, FormListener} from "../form/Form";
import {getContainer} from "../../ioc/IOCSetup";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {FormSubmitError, FormSubmitSuccess, FormSubmitSuccessHideFooter} from "../form/FormFeedback";
import {Submit} from "../form/Submit";
import {Validators} from "../form/Validators";
import {SelectInput} from "../form/SelectInput";
import {MonetaryConfigService} from "../../services/MonetaryConfigService";
import {SettingsService} from "../../services/SettingsService";
import {FormIf} from "../form/Switch";


interface State extends LoadingViewState {
    tc? : MonetaryConfig;
    validationMap? : any;
    currencies? : CurrencyDefinition[];
}

export class EditTurnoverContributions extends RouterView<RouteComponentProps,State> implements FormListener<MonetaryConfig>{

    service : MonetaryConfigService;
    settingsService : SettingsService;

    constructor(props : RouteComponentProps){
        super(props);
        this.service = getContainer().getMonetaryConfigService();
        this.settingsService = getContainer().getSettingsService();
        this.state = { tc : {}, validationMap : {}, currencies : [] };
    }

    getTitle(): string {
        if((this.props.match.params as any).id !== "new") {
            return "Edit Monetary Config";
        }
        return "Monetary Config";
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : State) {
        if((prevProps.match.params as any).id !== (this.props.match.params as any).id)  {
            this.refreshContent();
        }
    }

    
    loadContent(): Promise<any>  {
        if((this.props.match.params as any).id !== "new") {
            return this.service.getEntity((this.props.match.params as any).id).then((tc : TurnoverContributions) => {
                return this.settingsService.getSettings().then( (s : Settings) => {
                    this.setState({ tc : tc, currencies : s.currencies});
                })

            });
        }
        if((this.props.match.params as any).id === "new") {
            this.setState({ tc : {}});
        }
        return this.settingsService.getSettings().then( (s : Settings) => {
            this.setState({  currencies : s.currencies});
        })

    }

    onSubmit()  {
        if(!this.state.tc) return;
        const monetaryConfig = this.state.tc;
        if (monetaryConfig.maxPaidPeriodUnit === PeriodTimeUnit.DAYS && monetaryConfig.maxPaidPeriodValue! > 90){
            return Promise.reject("User can not set cap period to more than 90 days")
        }
        return this.service.save(this.state.tc).then((s : MonetaryConfig)=> {
            this.setState({tc : s});
            setTimeout(() => {
                this.props.history.push("/bonus/monetary-config/".concat(s.id!.toString()));
            }, 5000);
        })
    }

    formDidUpdate(formModel: GameTag, validationMap?: any) {
        this.setState({tc : formModel, validationMap : validationMap})
    }
    getCurrencyLabel(code : string) {
        if(this.state.currencies) {
            let c = this.state.currencies.find( c => c.code === code);
            if(c) {
                return c.name + " (" + c.code + ")";
            }
        }
        return "";
    }

    getPartialPayoutPercentageLabel(percentage : number) {
        if(percentage===0.1){
            return "10 % payouts";
        }
        else if(percentage===0.2){
            return "20 % payouts";
        }
        else if(percentage===0.25){
            return "25 % payouts";
        }
        else if(percentage===0.5){
            return "50 % payouts";
        } else {
            return "Invalid percentage";
        }
    }

    renderContent() {
        

        if(!this.state.tc || !this.state.currencies) {
            return <span></span>
        }

        return (
            <div>
                <div className="wrapper wrapper-content animated fadeInRight">
                    <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.tc} formListener={this}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card-box">
                                    <div className="ibox-content">
                                        {(this.props.match.params as any).id !== "new" && (   <div className="hr-line-dashed"></div> )}

                                        {(this.props.match.params as any).id !== "new" && (
                                            <FormGroup className="form-group">
                                                <label className="col-sm-2 control-label">ID</label>
                                                <div className="col-sm-10">
                                                    <FormInput  model="id" type="integer"  className="form-control" disabled={true}/>
                                                </div>
                                            </FormGroup>
                                        )}

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Name</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="name" validators={[Validators.required()]} type="text"  className="form-control" />
                                                <span className={"help"}>Internal name of this turnover contribution</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Currency Code</label>
                                            <div className="col-sm-10">
                                                <SelectInput  model="currencyCode" optional={false} values={ this.state.currencies.map( c => c.code)}  displayValue={(code : string) => this.getCurrencyLabel(code)} className="form-control" />
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Award Target</label>
                                            <div className="col-sm-10">
                                                <SelectInput  model="awardTarget" optional={false} values={Object.keys(AwardTarget)} className="form-control" />
                                                <span className={"help"}> When the bonus money is awarded to the player. It can be awarded as both bonus money or real money depending on the bonusThis field tells the system where to payout the bonus. i.e.. <br/>
                                                BONUS - Pays to the bonus balance.<br/>
                                                MAIN - Main Balance.
                                                </span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Award Type</label>
                                            <div className="col-sm-10">
                                                <SelectInput  model="awardType" optional={false} values={Object.keys(AwardType)} className="form-control" />
                                                <span className={"help"}>When the bonus money is awarded to the player. It can be awarded as both bonus money or real money depending on the bonus. <br/>
                                                CLAIMED - Real or Playable Bonus Money when the bonus is claimed by the player<span className="text-danger"> - NOT IMPLEMENTED YET</span><br/>
                                                RUNNING - Money are paid out at different times during the bonus lifecycle.<br/>
                                                COMPLETED - Money are paid out when the user completes the requirements of the bonus
                                                </span>
                                            </div>
                                        </FormGroup>

                                        
                                        <FormIf model={"awardType"} value={AwardType.RUNNING}>
                                        <div className="hr-line-dashed"></div>
                                            <FormGroup className="form-group">
                                                <label className="col-sm-2 control-label">Partial Payout Percentage</label>
                                                <div className="col-sm-10">
                                                    <SelectInput model="partialPayoutPercentage" validators={[Validators.required(), Validators.number()]} optional={true} values={[0.1,0.2,0.25,0.5]}  displayValue={(code : string) => this.getPartialPayoutPercentageLabel(Number(code))} className="form-control" disabled={(this.props.match.params as any).id !== "new"} />
                                                    <span className={"help"}>Payouts will be performed on installments using this percentage except for the last payment which will be the remaining bonus balance. The payout installments amounts will be rounded to avoid too many decimals again except for the last payment which will have the full owed amount.</span>
                                                </div>
                                            </FormGroup>
                                        </FormIf>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Max Input Amount</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="maxInputAmount" validators={[Validators.required(), Validators.number()]} type="float"  className="form-control" />
                                                <span className={"help"}>At what amount this bonus i capped. 1000 in max input amount for a deposit bonus would mean the bonus is only counted up to 1000.</span>
                                            </div>
                                        </FormGroup>


                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Min Input Amount</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="minInputAmount" validators={[Validators.required(), Validators.number()]} type="float"  className="form-control" />
                                                <span className={"help"}>At what amount this bonus is offered. 5 in min input amount for a deposit bonus would mean the bonus is only offered for deposits of 5 or more.</span>
                                            </div>
                                        </FormGroup>



                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Award Amount Fraction</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="awardAmountFraction" validators={[Validators.required(), Validators.number()]} type="float"  className="form-control" />
                                                <span className={"help"}>Multiplied with the input amount (ie deposit amount) to set how much bonus the player will receive. If set to 2 the user will receive 200% bonus.</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Turnover Requirement Factor</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="turnoverRequirementFactor" validators={[Validators.required(), Validators.number()]} type="float"  className="form-control" />
                                                <span className={"help"}>How many times the bonus a player is awarded he needs to turnover the bonus for it to be completed</span>
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Max Wager Amount</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="maxWagerAmount" validators={[Validators.number(), Validators.required()]} type="float"  className="form-control" />
                                                <span className={"help"}>The maximum wager amount that will contribute to a bonus turnover. The wagers will be capped at this amount</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <div className="col-sm-10">
                                                <div className="custom-control custom-checkbox">
                                                    <FormInput className="custom-control-input" model="maxPaidIgnoreGlobalSettings" id={"maxPaidIgnoreGlobalSettings"} type="checkbox"/>
                                                    <label htmlFor={"maxPaidIgnoreGlobalSettings"} className={"custom-control-label"}>Ignore Global Limits</label>
                                                </div>
                                                <span className={"help"}>When checked this bonus will ignore global limits.</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                            <h4 className="col-sm-2 control-label">Bonus Cap</h4>
                                            <br/>
                                            <span className={"help"}>** If any value below is missing or is 0 the cap validation is not performed.<br/>
                                            ** Because of database restrictions Period Value can not be higher than 90 days.
                                            </span>
                                            <br/>
                                            <br/>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Max Amount</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="maxPaidTotalAmount" validators={[Validators.number()]} type="float"  className="form-control" />
                                                <span className={"help"}>The maximum bonus paid amount allowed within the configured timeframe. If 0 then no bonus can be awarded.</span>
                                            </div>
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Period Type</label>
                                            <div className="col-sm-10">
                                                <SelectInput  model="maxPaidPeriodUnit" optional={true} values={Object.keys(PeriodTimeUnit)} className="form-control" />
                                                <span className={"help"}>The type of timeframe units that will be used to calculate the total bonus paid amount.</span>
                                            </div>
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Period Value</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="maxPaidPeriodValue" validators={[Validators.number()]} type="float"  className="form-control" />
                                                <span className={"help"}>The number of units that will be considered when calculating bonus paid amount.</span>
                                            </div>
                                        </FormGroup>
                                        
                                    </div>
                                </div>



                            </div>

                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card-box">
                                    <FormSubmitError />
                                    {(this.props.match.params as any).id === "new" && (           
                                        <FormSubmitSuccessHideFooter text="Monetary Config was created successfully"/>
                                    )}
                                    {(this.props.match.params as any).id !== "new" && (           
                                        <FormSubmitSuccess text="Monetary Config was updated successfully"/>
                                    )}
                                    <div className="form-group">
                                        <div className="col-sm-12">
                                            <Submit className="btn  btn-primary">Save</Submit>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

}

export default withRouter(EditTurnoverContributions);